import * as React from "react";
function SvgSmiley(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <path d="M24 2.4c11.9 0 21.6 9.7 21.6 21.6S35.9 45.6 24 45.6 2.4 35.9 2.4 24 12.1 2.4 24 2.4M24 0C10.8 0 0 10.8 0 24s10.8 24 24 24 24-10.8 24-24c0-6.2-2.5-12.2-6.8-16.8C36.7 2.5 30.5 0 24 0zm-.1 36.4c-4.2 0-8.3-1.7-11.4-4.6-.5-.5-.5-1.2 0-1.7s1.2-.5 1.7 0c5.6 5.4 14.5 5.2 19.8-.5.5-.5 1.2-.5 1.7 0s.5 1.2 0 1.7c-3 3.1-7.2 5-11.5 5h-.3zm-6.7-21.2c1.4 0 2.6 1.3 2.6 3s-1.2 3-2.6 3-2.6-1.3-2.6-3c-.1-1.6 1.1-3 2.6-3zm14 0c1.4 0 2.6 1.3 2.6 3s-1.2 3-2.6 3c-1.4 0-2.6-1.3-2.6-3 0-1.6 1.2-3 2.6-3z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgSmiley);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
